import { render, staticRenderFns } from "./CheckBoxGroup.vue?vue&type=template&id=b042097a&"
import script from "./CheckBoxGroup.vue?vue&type=script&lang=js&"
export * from "./CheckBoxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports